import React from 'react'
import { SystemBase } from './../common/SystemBase';
import { ISystemBase} from './../types/ISystemBase';
import { Upload, UploadOnStatusChangeEvent, UploadFileInfo } from '@progress/kendo-react-upload';
import { toast } from 'react-toastify';

interface ISystemUpload  {
    /*Specifies the allowed extension of the component.*/
    extension: string,
    SaveUrl: string,
    AllowMultipleFile: boolean
    onStatusChange: any,
    AutoUpload?: boolean
}
/**
 * Creates an Input with Label  
 * */




export default class SystemLargFileUploader extends SystemBase<ISystemUpload>
{


    constructor(props: any) {
        super(props)

        var allowedExtension = this.props.extension.split(',');
    }
    onStatusChange = (event: UploadOnStatusChangeEvent) => {
        if (event != undefined) {
            this.props.onStatusChange(event);
        }
    };

    render() {

        return (
            <this.WrapperDiv>
               
                <Upload
                    batch={false}
                    multiple={this.props.AllowMultipleFile}
                    defaultFiles={[]}
                    withCredentials={false}
                    saveUrl={this.props.SaveUrl}
                    onStatusChange={this.onStatusChange}
                    id="fileUploadImage"
                    className="form-control"
                    accept={this.props.extension}
                   // onAdd={this.handleChange}
                    autoUpload={this.props.AutoUpload}
                    responseType={"text"}
                    restrictions={{
                        allowedExtensions: this.props.extension.split(',')
                    }
                    }
                    />
                  
            </this.WrapperDiv>
        );
    }
}

